function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import { IconHandler } from '../../Icons';
import injectStyles from '../../jss';
import LoanLimitSliderOverlay from './LoanLimitSliderOverlay.react';
import ReactSlider from 'react-slider';
import SliderOverlay from './SliderOverlay.react';
import SliderSteps from './SliderSteps.react';
import styles from './Slider.jss';
var HANDLE_BARS_CLASS_NAME = 'handle-bars';
export var Slider = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Slider, _React$PureComponent);
  function Slider() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Slider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Slider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isBeingDragged: false
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSliderChange", function (value) {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        onChange = _this$props.onChange;
      if (disabled) {
        return;
      }
      onChange(value);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBeforeSliderChange", function (value) {
      var _this$props2 = _this.props,
        disabled = _this$props2.disabled,
        onBeforeChange = _this$props2.onBeforeChange;
      if (disabled) {
        return;
      }
      if (onBeforeChange) {
        onBeforeChange(value);
      }
      _this.setState({
        isBeingDragged: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onAfterSliderChange", function (value) {
      var _this$props3 = _this.props,
        disabled = _this$props3.disabled,
        onAfterChange = _this$props3.onAfterChange;
      if (disabled) {
        return;
      }
      if (onAfterChange) {
        onAfterChange(value);
      }
      _this.setState({
        isBeingDragged: false
      });
    });
    return _this;
  }
  _createClass(Slider, [{
    key: "getTooltipValue",
    value: function getTooltipValue() {
      var _this$props4 = this.props,
        handlerFormatter = _this$props4.handlerFormatter,
        value = _this$props4.value,
        unit = _this$props4.unit,
        classes = _this$props4.classes;
      return React.createElement("div", null, handlerFormatter(value), " ", React.createElement("span", {
        className: classes.unit
      }, unit));
    }
  }, {
    key: "getHandlerValue",
    value: function getHandlerValue() {
      var _this$props5 = this.props,
        handlerFormatter = _this$props5.handlerFormatter,
        value = _this$props5.value;
      return React.createElement("div", null, handlerFormatter(value));
    }
  }, {
    key: "getHandlerIcon",
    value: function getHandlerIcon() {
      var _this$props6 = this.props,
        classes = _this$props6.classes,
        CustomIconHandler = _this$props6.handlerIcon;
      return CustomIconHandler || React.createElement(IconHandler, {
        className: classes.sliderHandleBarsIcon
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        barHeight = _this$props7.barHeight,
        classes = _this$props7.classes,
        defaultValue = _this$props7.defaultValue,
        disabled = _this$props7.disabled,
        formater = _this$props7.formater,
        hasValueInHandler = _this$props7.hasValueInHandler,
        hasValueInTooltip = _this$props7.hasValueInTooltip,
        height = _this$props7.height,
        kind = _this$props7.kind,
        loanLimit = _this$props7.loanLimit,
        max = _this$props7.max,
        min = _this$props7.min,
        shakySteps = _this$props7.shakySteps,
        step = _this$props7.step,
        stepHeight = _this$props7.stepHeight,
        exactSteps = _this$props7.exactSteps,
        unit = _this$props7.unit,
        value = _this$props7.value,
        stepLabels = _this$props7.stepLabels,
        emphasizedValues = _this$props7.emphasizedValues,
        persistentTooltip = _this$props7.persistentTooltip,
        className = _this$props7.className;
      var sliderValue = value === null || value === undefined ? defaultValue : value;
      var handlerClassName = this.getHandlerClassName(sliderValue);
      var isBeingDragged = this.state.isBeingDragged;
      return React.createElement("div", {
        className: classnames("slider-".concat(kind), className, classes.sliderContainer)
      }, loanLimit && React.createElement(LoanLimitSliderOverlay, {
        loanLimit: loanLimit,
        max: max,
        min: min,
        className: classes.sliderBarActiveLoanLimit,
        value: sliderValue
      }), disabled && React.createElement(SliderOverlay, {
        className: classes.sliderBarDisabled
      }), React.createElement(SliderSteps, {
        barHeight: barHeight,
        defaultValue: defaultValue,
        formater: formater,
        height: height,
        max: max,
        min: min,
        shakySteps: shakySteps,
        step: step,
        stepHeight: stepHeight,
        exactSteps: exactSteps,
        stepLabels: stepLabels,
        unit: unit,
        emphasizedValues: emphasizedValues,
        value: value
      }), React.createElement(ReactSlider, {
        defaultValue: defaultValue,
        disabled: disabled,
        max: max,
        min: min,
        onAfterChange: this.onAfterSliderChange,
        onBeforeChange: this.onBeforeSliderChange,
        onChange: this.onSliderChange,
        step: step,
        value: sliderValue,
        withBars: true
      }, React.createElement("div", {
        className: handlerClassName
      }, hasValueInTooltip && (isBeingDragged || persistentTooltip) && React.createElement("div", {
        className: classes.valueTooltip
      }, this.getTooltipValue()), hasValueInHandler ? this.getHandlerValue() : this.getHandlerIcon())));
    }
  }, {
    key: "getHandlerClassName",
    value: function getHandlerClassName(value) {
      var _this$props8 = this.props,
        classes = _this$props8.classes,
        disabled = _this$props8.disabled,
        hasValueInHandler = _this$props8.hasValueInHandler,
        loanLimit = _this$props8.loanLimit,
        handlerClass = _this$props8.handlerClass;
      var defaultClassName = classnames(HANDLE_BARS_CLASS_NAME, handlerClass, _defineProperty({}, classes.handlerValue, hasValueInHandler));
      if (disabled) {
        return classnames(defaultClassName, classes.handleDisabled);
      }
      if (loanLimit && value > loanLimit) {
        return classnames(defaultClassName, classes.handleLoanLimit);
      }
      return defaultClassName;
    }
  }]);
  return Slider;
}(React.PureComponent);
_defineProperty(Slider, "styleRoot", 'Slider');
_defineProperty(Slider, "defaultProps", {
  barHeight: 4,
  defaultValue: 5,
  formater: function formater(value, unit) {
    return "".concat(unit, " ").concat(value);
  },
  handlerFormatter: function handlerFormatter(value) {
    return "".concat(value);
  },
  hasValueInHandler: false,
  hasValueInTooltip: false,
  height: 32,
  handlerWidth: 100,
  max: 10,
  min: 1,
  step: 1,
  stepHeight: 10
});
export default injectStyles(styles)(Slider);